import React from 'react';
import { useIntl } from 'react-intl';
import DropdownCell from '@/components/table/DropdownCell';
import { ATTACHMENT_TRANSFER } from '../constants';
import Events from '../hooks/events';

const listItems = (intl) => Object.values(ATTACHMENT_TRANSFER)
  .sort((a, b) => a.order - b.order)
  .map(({ name, icon }) => ({
    key: `dataset_attachments_transferable_${name}`,
    icon,
    text: intl.formatMessage({ id: `dataset.attachments.transferable.${name}` }),
    value: name,
  }));

const AttachmentTransferableCell = ({
  attachment,
  category,
  code,
  disabled,
  isLoading,
  upward,
}) => {
  const intl = useIntl();
  const updateMetadata = Events.useUpdateDatasetAttachmentMetadata({ category, code });
  const { metadata, id: attachmentId } = attachment;

  return (
    <DropdownCell
      className="primary"
      disabled={disabled}
      isLoading={isLoading}
      onChange={(e, { value: transferable }) => { updateMetadata({ attachmentId, metadata: { transferable } }); }}
      options={listItems(intl)}
      upward={upward}
      value={metadata.transferable}
    />
  );
};

export default AttachmentTransferableCell;
